import 'jquery-mask-plugin/dist/jquery.mask.min.js'
import 'jquery-validation/dist/jquery.validate.js'
import '../../scss/components/contact-form'
import { displayProgress, scroll } from '../libs/utils'

import 'toastr/toastr.scss'
import '../../scss/components/estimateForms'

// Setup
const settings = require('../../common.json')
const nJsonData = require('../../simulators.json')
const categoryIncome = require('../../category_income.json')
// const travauxData = require('../../renovation_work.json')
settings.messages = $.extend({}, settings.messages, nJsonData.messages)

const person1 = require('../../../assets/img/simulateur/1-personne.svg')
const person2 = require('../../../assets/img/simulateur/2-personnes.svg')
const person3 = require('../../../assets/img/simulateur/3-personnes.svg')
const person4 = require('../../../assets/img/simulateur/4-personnes.svg')
const person5 = require('../../../assets/img/simulateur/5-personnes.svg')
const person5plus = require('../../../assets/img/simulateur/plus-5-personnes.svg')

$(function () {
  $('[data-toggle="tooltip"]').tooltip({
    animated: 'fade',
    html: true
  })
})

const personnes = {
  1: { text: '1', icon: person1 },
  2: { text: '2', icon: person2 },
  3: { text: '3', icon: person3 },
  4: { text: '4', icon: person4 },
  5: { text: '5', icon: person5 },
  '5+': { text: '+ 5', icon: person5plus }
}

const simulatorHelpsForm = {
  id: 'simulator-section',
  csteps: '.fsh',
  projectType: null,
  pristineForm: [],
  captcha: null,

  execute () {
    console.log('execute')
  },

  initStep (s, p) {
    s = s === 'contact' ? s : parseInt(s)
    const self = this
    const _p = $(self.csteps + '[step="' + p + '"]')
    const _cs = $(self.csteps + '[step="' + s + '"]')
    $.each($(self.csteps), function (i, elem) {
      $(elem).removeClass('d-none')
      if ($(elem).attr('step') === 'contact') {
        $(elem).hide()
      }
      if ($(elem).attr('step') > s) {
        $(elem).hide()
        $(elem)
          .find('.heading')
          .removeClass('text-success')
          .addClass('text-info')
      } else {
        $(elem)
          .find('.heading')
          .addClass('text-success')
          .removeClass('text-info')
      }
    })
    // _p.hide()
    _cs.show()
    // _cs.find('.heading').removeClass('text-success').addClass('text-info')
    scroll(_cs)
    self.initForms(s, p)
    displayProgress('#' + self.id, true, _cs.attr('percent'))
  },

  previous (s) {
    let p
    s = parseInt(s)
    if (s > 1) {
      p = s - 1
    }
    const _p = $(this.csteps + '[step="' + p + '"]')
    _p.show()
    this.initStep(p, p)
    scroll(_p)
  },

  initForms (s, p) {
    const self = this
    const layer = document.getElementById(this.id)
    const _cs = $(self.csteps + '[step="' + s + '"]')
    s = s === 'contact' ? s : parseInt(s)
    _cs
      .find('button.previous')
      .off()
      .on('click', function () {
        self.previous(s)
      })

    // étape 1 : Localisation
    if (s === 1) {
      // reset
      _cs
        .find('button:not(.previous)')
        .removeClass('active btn-success')
        .addClass('btn-outline-light')
      _cs.removeAttr('sel')
      // on click
      _cs
        .find('button:not(.previous)')
        .off()
        .on('click', function () {
          _cs.attr('sel', $(this).attr('val'))
          self.localisation = $(this).attr('val')
          _cs
            .find('button:not(.previous)')
            .removeClass('active btn-success')
            .addClass('btn-outline-light')
          $(this)
            .addClass('active btn-success')
            .removeClass('btn-outline-light')
          const _next = $(this).attr('next')
          $.each($(self.csteps), function (i, elem) {
            if ($(elem).attr('step') > s) {
              $(elem).hide()
            }
          })
          self.initStep(_next, s)
        })
    }

    // étape 2 : Année de construction
    if (s === 2) {
      // reset
      _cs
        .find('button:not(.previous)')
        .removeClass('active btn-success')
        .addClass('btn-outline-light')
      _cs.removeAttr('sel')
      // on click
      _cs
        .find('button:not(.previous)')
        .off()
        .on('click', function () {
          _cs.attr('sel', $(this).attr('val'))
          self.yearBuild = $(this).text()
          _cs
            .find('button:not(.previous)')
            .removeClass('active btn-success')
            .addClass('btn-outline-light')
          $(this)
            .addClass('active btn-success')
            .removeClass('btn-outline-light')
          const _next = $(this).attr('next')
          $.each($(self.csteps), function (i, elem) {
            if ($(elem).attr('step') > s) {
              $(elem).hide()
            }
          })
          self.initStep(_next, s)
        })
    }

    // étape 3 : Type de résidant
    if (s === 3) {
      // reset
      _cs
        .find('button:not(.previous)')
        .removeClass('active btn-success')
        .addClass('btn-outline-light')
      _cs.removeAttr('sel')
      // on click
      _cs
        .find('button:not(.previous)')
        .off()
        .on('click', function () {
          _cs.attr('sel', $(this).attr('val'))
          self.typeR = $(this).text()
          _cs
            .find('button:not(.previous)')
            .removeClass('active btn-success')
            .addClass('btn-outline-light')
          $(this)
            .addClass('active btn-success')
            .removeClass('btn-outline-light')
          const _next = $(this).attr('next')
          $.each($(self.csteps), function (i, elem) {
            if ($(elem).attr('step') > s) {
              $(elem).hide()
            }
          })
          self.initStep(_next, s)
        })
    }

    // étape 4 : Nombre de personnes
    if (s === 4) {
      const $select = $("select[name='personnes']")
      const $wrapper = $('#nombres_personnes_wrapper')

      const formPersonnes = layer.querySelector(
        'form[name="fsh_personnes_form"]'
      )

      const submitPersonnes = (e) => {
        e.preventDefault()
        self.initStep('5', s)
        formPersonnes.classList.add('was-validated')
      }
      formPersonnes.removeEventListener('submit', submitPersonnes)
      formPersonnes.addEventListener('submit', submitPersonnes)

      if (s === 4 && p === 3) {
        $wrapper.empty()
        const $ul = $(
          '<ul class="list-unstyled row justify-content-center"></ul>'
        )

        $.each(personnes, function (number, item) {
          $select.append(
            $('<option>', {
              value: number,
              text: item.text
            })
          )

          const $li = $('<li class="col py-2"></li>')
          const $card = $(
            `
              <div class="people-item d-flex flex-column align-items-center justify-content-center overflow-hidden extend-click h-100">
                <img src="` +
              item.icon +
              `">
                <div class="content">
                  <div class="desc row align-items-center">
                    <span class="col title h6 poppins text-uppercase text-center font-weight-normal">
                      ` +
              item.text +
              `
                    </span>
                  </div>
                </div>
              </div>`
          )
            .attr('val', number)
            .on('click', function () {
              $('.people-item').removeClass('active')
              $select.find('option').prop('selected', false)

              // Ajouter "active" à la carte cliquée et sélectionner l'option correspondante
              $(this).addClass('active')
              $select
                .find("option[value='" + number + "']")
                .prop('selected', true)
            })

          $li.append($card)
          $ul.append($li)
        })

        $wrapper.append($ul)
      }
    }

    // étape 5 : RFR
    if (s === 5) {
      const isInIdf = self.localisation === 'idf'

      let incomes = []
      // const incomeToAdd = 0

      const nbPeople = layer.querySelector('.people-item.active').attributes.val
        .value

      // Si en IDF
      if (isInIdf) {
        incomes = categoryIncome.idf[nbPeople === '5+' ? 5 : nbPeople]
        // incomeToAdd = categoryIncome.idf.more
      } else {
        incomes = categoryIncome.hidf[nbPeople === '5+' ? 5 : nbPeople]
        // incomeToAdd = categoryIncome.hidf.more
      }

      const blueBtn = layer.querySelector('button[val="blue"]')
      const yellowBtn = layer.querySelector('button[val="yellow"]')
      const magentaBtn = layer.querySelector('button[val="magenta"]')
      const pinkBtn = layer.querySelector('button[val="pink"]')

      const blue = Intl.NumberFormat('fr-FR').format(incomes.blue) + ' €'
      const yellow = Intl.NumberFormat('fr-FR').format(incomes.yellow) + ' €'
      const magenta = Intl.NumberFormat('fr-FR').format(incomes.magenta) + ' €'
      const pink = Intl.NumberFormat('fr-FR').format(incomes.pink) + ' €'

      blueBtn.innerHTML = 'Moins de ' + blue
      yellowBtn.innerHTML = 'Entre ' + blue + ' et ' + yellow
      magentaBtn.innerHTML = 'Entre ' + yellow + ' et ' + magenta
      pinkBtn.innerHTML = 'Plus de ' + pink

      // reset
      _cs
        .find('button:not(.previous)')
        .removeClass('active btn-success')
        .addClass('btn-outline-light')
      _cs.removeAttr('sel')
      // on click
      _cs
        .find('button:not(.previous)')
        .off()
        .on('click', function () {
          _cs.attr('sel', $(this).attr('val'))
          self.income = $(this).attr('val')
          self.calculatedIncome = $(this).text()
          _cs
            .find('button:not(.previous)')
            .removeClass('active btn-success')
            .addClass('btn-outline-light')
          $(this)
            .addClass('active btn-success')
            .removeClass('btn-outline-light')
          $.each($(self.csteps), function (i, elem) {
            if ($(elem).attr('step') > s) {
              $(elem).hide()
            }
          })
          self.initStep(6, s)
        })
    }

    // étape 6 : résultat
    if (s === 6) {
      const title = layer.querySelector('span[id="first-result-title"]')

      title.innerHTML =
        "Vous êtes éligibles aux aides de l'état jusqu’à " +
        Intl.NumberFormat('fr-FR').format(
          categoryIncome.ceiling.max.bonus[self.income]
        ) +
        '€'

      const table = $('#table_aides')
      const montant4lettres = table.find('#4_lettres_montant')
      montant4lettres.text(
        Intl.NumberFormat('fr-FR').format(
          categoryIncome.ceiling['4'][self.income] +
            categoryIncome.ceiling.max[4] * 0.1
        ) + '€'
      )
      const montant3lettresbonus = table.find('#3_lettres_montant_bonus')
      montant3lettresbonus.text(
        Intl.NumberFormat('fr-FR').format(
          categoryIncome.ceiling['3'][self.income] +
            categoryIncome.ceiling.max[3] * 0.1
        ) + '€'
      )
      const montant3lettres = table.find('#3_lettres_montant')
      montant3lettres.text(
        Intl.NumberFormat('fr-FR').format(
          categoryIncome.ceiling['3'][self.income]
        ) + '€'
      )
      const montant2lettresbonus = table.find('#2_lettres_montant_bonus')
      montant2lettresbonus.text(
        Intl.NumberFormat('fr-FR').format(
          categoryIncome.ceiling['2'][self.income] +
            categoryIncome.ceiling.max[2] * 0.1
        ) + '€'
      )
      const montant2lettres = table.find('#2_lettres_montant')
      montant2lettres.text(
        Intl.NumberFormat('fr-FR').format(
          categoryIncome.ceiling['2'][self.income]
        ) + '€'
      )

      // reset
      _cs
        .find('button:not(.previous)')
        .removeClass('active btn-success')
        .addClass('btn-outline-light')
      _cs.removeAttr('sel')
      // on click
      _cs
        .find('button:not(.previous)')
        .off()
        .on('click', function () {
          self.formType = $(this).attr('val')
          _cs.attr('sel', $(this).attr('val'))
          _cs
            .find('button:not(.previous)')
            .removeClass('active btn-success')
            .addClass('btn-outline-light')
          $(this)
            .addClass('active btn-success')
            .removeClass('btn-outline-light')
          const _next = $(this).attr('next')
          $.each($(self.csteps), function (i, elem) {
            if ($(elem).attr('step') > s) {
              $(elem).hide()
            }
          })
          self.initStep(_next, s)
        })
    }

    // Ici on veut renseigner les champs qu'on peut déjà renseigner avec les questions précédentes
    if (s === 'contact' && p === 6) {
      const $f = $('form[id="contact_form"]')
      $f.find('button, input, textarea, select')
        .prop('disabled', true)
        .css({ opacity: 0.5 })
      import('./contact-form.js').then(() => {
        $f.find('button, input, textarea, select')
          .prop('disabled', false)
          .css({ opacity: 1 })
      })

      const nbPeople = layer.querySelector('.people-item.active').attributes.val
        .value
      const formMsg = $f.find('textarea[name="demand"]')
      const income = self.income
      // On remplace les espaces insécables pour le mail
      const calculatedIncome = self.calculatedIncome.replace(/\s/g, ' ')

      let formContent = ''

      if (self.formType === 'contactDevis') {
        formContent =
          "Bonjour,\nJe souhaite être accompagné pour la rénovation énergétique de mon logement et bénéficier d'un devis travaux gratuit.\n\n"
      } else {
        formContent =
          "Bonjour,\nJe souhaite être accompagné pour la rénovation énergétique de mon logement et bénéficier d'un audit énergétique gratuit.\n\n"
      }

      switch (nbPeople) {
        case '1':
          formContent += 'Je suis le seul résident du logement.\n'
          break
        case '5+':
          formContent += 'Nous sommes plus de 5 à résider dans le logement.\n'
          break
        default:
          formContent +=
            'Nous sommes ' +
            nbPeople.toString() +
            ' à résider dans le logement.\n'
          break
      }

      formContent += '\n'

      formContent +=
        'Revenu fiscal de référence :\n' +
        calculatedIncome +
        ' (catégorie ' +
        categoryIncome.trad[income] +
        ')\n'

      const typePerson = self.typeR

      formContent += '\n'
      formContent +=
        'Voici des informations supplémentaires sur mon logement :\n'
      formContent += '- Date de construction : ' + self.yearBuild + '\n'
      formContent += '- Je suis : ' + typePerson + '\n'

      formContent += '\nBien cordialement,'

      formMsg.val(formContent)
    }
  },

  init () {
    this.initStep(1)
  }
}

simulatorHelpsForm.init()
